import React from 'react';
import { IconProps } from '../IconProps';

export const LogsIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.375 19.3848C17.1364 19.3848 19.375 17.1462 19.375 14.3848C19.375 11.6233 17.1364 9.38477 14.375 9.38477C11.6136 9.38477 9.375 11.6233 9.375 14.3848C9.375 17.1462 11.6136 19.3848 14.375 19.3848Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.375 11.8848V16.8848"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.375 16.8848L12.5 15.0098"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.375 16.8848L16.25 15.0098"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.375 8.75977H8.75"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.375 11.8848H6.875"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.375 15.0098H6.875"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.125 19.3848H1.875C1.18464 19.3848 0.625 18.8251 0.625 18.1348V5.00977C0.625 4.31941 1.18464 3.75977 1.875 3.75977H5C5 2.03388 6.39911 0.634766 8.125 0.634766C9.85089 0.634766 11.25 2.03388 11.25 3.75977H14.375C15.0654 3.75977 15.625 4.31941 15.625 5.00977V6.88477"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.125 3.13477C8.29759 3.13477 8.4375 3.27468 8.4375 3.44727C8.4375 3.61985 8.29759 3.75977 8.125 3.75977C7.95241 3.75977 7.8125 3.61985 7.8125 3.44727C7.8125 3.27468 7.95241 3.13477 8.125 3.13477"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
